import {compose} from 'recompose';
import {constructSparkEnhancer, withIntl} from '@ciscospark/spark-widget-base';
import {enhancer as mercuryEnhancer} from '@ciscospark/redux-module-mercury';

import reducers from './reducer';
import ConnectedSpace from './container';
import messages from './translations/en';
import events from './events';
import {destinationTypes} from './constants';

const {eventNames} = events;

export {eventNames};

export {reducers};

export {destinationTypes};

export default compose(
  constructSparkEnhancer({
    name: 'space',
    reducers
  }),
  mercuryEnhancer,
  withIntl({locale: 'en', messages})
)(ConnectedSpace);
